import { AxiosInstance } from 'axios';
import { GmailLabel } from './GmailSourceSettings.types';

export class GmailSourceSettingsApi {
	constructor(private client: AxiosInstance) {}

	async getLabels(boardId: string, connectionId: string): Promise<GmailLabel[]> {
		const response = await this.client.get<GmailLabel[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/gmail/labels`,
		);

		return response.data;
	}
}
